module.exports = __webpack_public_path__ + "b002e0ab.ttf";